import './account_mapping'
import './delete-reconciliation-details'
import './account-entries-modal'
import './accounts-rounding-configuration'
import './account-entries'
import './account-trend-chart'
import './accounts/edit-modal-form'
import './adjustments'
import './adjustments-form'
import './check-lists'
import './company-users'
import './details'
import './diff'
import './edit-partner-segment'
import './import_ledger_form'
import setupLogRocket from './setup-log-rocket'
import setupReloadOTPBanner from './setup-reload-otbanner'
import setupAppcues from './setup-appcues'
import './manual-ledger-upload'
import setupRemarkTags from './setup-remark-tags'
import './set-current-ledger'
import setupAccordion from './setup-accordion'
import setupAdjustmentImports from './setup-adjustment-imports'
import setupAdministrationSyncEntities from './setup-administration-sync-entities'
import setupTurbolinksNavigationFixes from './setup-turbolinks-navigation-fixes'
import setupCompaniesRecentlyVisited from './companies-recently-visited'
import setupAdjustmentLink from './setup-adjustment-link'
import './toggle_adjustments_table'
import './select-retained-earnings-account'
import './auto-reload-page'
import './userlane'
import './workflow-statuses-reorder'
import './wait-for-mum'
import './trigger-tutorial'
import './period-specific-documents'
import './audit-log-show-more'
import setupAdvancedOption from './setup-sync-advanced-option'
import './admin-bulk-lock-ledgers'
import './admin-migrate-mapping-list-progress'
import './shared-template-configurations'
import './share-trigger'
import './share-trigger-mode'
import setupReconciliationProposal from './setup-reconciliation-proposal'
import setupFixedTableHeaders from './fixed-table-headers'
import setupValidateRequiredFields from './validate-required-fields'
import setupDrawers from './setup-drawers'
import setupSearchInput from './setup-search-input'

setupAdvancedOption()
setupLogRocket()
setupReloadOTPBanner()
setupAppcues()

setupAccordion()
setupAdjustmentImports()
setupAdministrationSyncEntities()

setupDrawers()

setupAdjustmentLink()

setupReconciliationProposal()

setupFixedTableHeaders()

setupRemarkTags()

setupSearchInput()

setupTurbolinksNavigationFixes()
setupValidateRequiredFields()

setupCompaniesRecentlyVisited()

// DOMAINS
import '@app/application/budget/behaviours'
import '@app/application/communication/behaviours'
import '@app/application/ai_ocr_documents/behaviours'
import '@app/application/document/behaviours'
import '@app/application/export/behaviours'
import '@app/application/layout/behaviours'
import '@app/application/marketplace/behaviours'
import '@app/application/miscellaneous/behaviours'
import '@app/application/reconciliation/behaviours'
import '@app/application/reconciliation_proposal/behaviours'
import '@app/application/report/behaviours'
import '@app/application/report-template/behaviours'
import setupReportEditor from '@app/application/report/behaviours/setup-report-editor'
import '@app/application/workflow-overview-navigation/behaviours'
import '@app/application/workflows/behaviours'
import '@app/application/pulse/behaviours'
import '@app/application/invoices/behaviours'
import '@app/application/ledger-audit-log/behaviours'
import '@app/application/sf-assistant-checks/behaviours'
import '@app/application/accounts/behaviours'
import '@app/application/wall-clock-time/behaviours'
import '@app/application/company_links/behaviours'

// Users
import './users/configure/email-notifications-form'
import './users/configure/enforce-sso-access-form'
import './users/user-select'

import './client-type-form'
setupReportEditor()
